import { REQUEST_FETCH_SEGMENTS, FETCH_SEGMENTS_SUCCESS, FETCH_SEGMENTS_ERROR } from './actionTypes';

export const requestFetchSegments = () => ({ type: REQUEST_FETCH_SEGMENTS });

export const fetchSegmentsSuccess = segments => ({ type: FETCH_SEGMENTS_SUCCESS, payload: segments });

export const fetchSegmentsError = error => ({ type: FETCH_SEGMENTS_ERROR, payload: error });
